import {selector} from "recoil";
import {unidadeGetResponseState} from "../atoms/unidadeGetResponseState";
import unidadesDistintasSelector from "./unidadesDistintasSelector";
import {GetUnidade} from "../../service/unidade-service";

const possuiFacialSelector = selector({
  key: 'possuiFacialSelector',
  get: async ({get}) => {
    const unidades = get(unidadesDistintasSelector);
    if ('REACT_APP_UNIDADES_COM_FACIAL' in process.env) {
      return !!unidades.find((unidade) => process.env.REACT_APP_UNIDADES_COM_FACIAL.split(',').includes(unidade.id.toString()))
    } else if (unidades.length > 0) {
      return !!unidades.find((unidade) => unidade.possuiFacial === true)
    }
    return true;
  },
});

export default possuiFacialSelector;